import { bindable } from "aurelia-framework";
import { ISchoolSettingsDto } from "typings/project";

export class NewSchoolModal {
  @bindable onSave: (school: ISchoolSettingsDto) => void;
  data: Array<ISchoolSettingsDto> = [];
  isOpen: boolean = false;

  school: ISchoolSettingsDto = <ISchoolSettingsDto>{};

  open(schoolSettings: Array<ISchoolSettingsDto>) {
    // Reset form
    this.school.schoolName = "";
    this.school.schoolCode = "";
    this.data = schoolSettings;
    this.isOpen = true;
    document.body.style.overflow = "hidden";
  }

  close() {
    this.isOpen = false;
    document.body.style.overflow = "";
  }

  save() {
    if (!this.school.schoolName || !this.school.schoolCode) {
      alert("Please fill in all fields");
      return;
    }
    if(this.data.filter(f => f.schoolName.toLocaleLowerCase() == this.school.schoolName.toLocaleLowerCase()).length > 0)
    {
      alert("A school already exists with this name.")
      return;
    }
                        

    if (this.onSave) { 
      this.onSave({ ...this.school });
    }

    this.close();
  }
}